import type { FC } from 'react'
import { useState } from 'react'

import UnableToVerifyButton from '@/components/UnableToVerifyButton'

import UnableToVerifyIncomeSidebar from './Sidebar'

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  incomeId: string
  incomeType: string
  incomeStatus: string
  companyName: string
  mandatedTrustedSourcesEnabled?: boolean
  showTrustedSourcesRequiredLabel?: boolean
  onSuccess: () => void
}

const UnableToVerifyIncome: FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  incomeId,
  incomeType,
  incomeStatus,
  companyName,
  mandatedTrustedSourcesEnabled,
  showTrustedSourcesRequiredLabel,
  onSuccess,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <UnableToVerifyIncomeSidebar
          customerId={customerId}
          applicationId={applicationId}
          subjectId={subjectId}
          incomeId={incomeId}
          incomeType={incomeType}
          incomeStatus={incomeStatus}
          companyName={companyName}
          mandatedTrustedSourcesEnabled={mandatedTrustedSourcesEnabled}
          showTrustedSourcesRequiredLabel={showTrustedSourcesRequiredLabel}
          onClose={() => setIsSidebarOpen(false)}
          onSuccess={onSuccess}
        />
      )}
      <UnableToVerifyButton onClick={() => setIsSidebarOpen(true)} />
    </>
  )
}

export default UnableToVerifyIncome
